import { render, staticRenderFns } from "./ConfirmPaymentOnestop.vue?vue&type=template&id=484488b2"
import script from "./ConfirmPaymentOnestop.vue?vue&type=script&lang=js"
export * from "./ConfirmPaymentOnestop.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPaymentOnestop.vue?vue&type=style&index=0&id=484488b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports